<script>
import { formRenderMixin } from '@/mixins/formRender';
import AppealDate from './actionData/AppealDate';
import Archive from './actionData/Archive';
import BeforeDocumentCreate from './actionData/BeforeDocumentCreate';
import BiK from './actionData/BiK';
import Certificate from './actionData/Certificate';
import Comment from './actionData/Comment';
import Confirm from './actionData/Confirm';
import ConfirmForm from './actionData/ConfirmForm';
import ConfirmMdokSubmit from './actionData/ConfirmMdokSubmit';
import DateRangeStart from './actionData/DateRangeStart';
import DecisionStart from './actionData/DecisionStart';
import DecisionEnd from './actionData/DecisionEnd';
import DeliveryDate from './actionData/DeliveryDate';
import Diploma from './actionData/Diploma';
import FileTransfer from './actionData/FileTransfer';
import GeneralDeed from './actionData/GeneralDeed';
import Invitation from './actionData/Invitation';
import Judgment from './actionData/Judgment';
import KoReport from './actionData/KoReport';
import ListOfSko from './actionData/ListOfSko';
import Mdok from './actionData/Mdok';
import NoForm from './actionData/NoForm';
import PrezydenckiData from './actionData/PrezydenckiData';
import Reason from './actionData/Reason';
import SchoolSubmitEPUAP from './actionData/SchoolSubmitEPUAP';
import SubmitEPUAP from './actionData/SubmitEPUAP';
import SubmitManually from './actionData/SubmitManually';
import SubmitSigned from './actionData/SubmitSigned';
import Address from './filters/Address';
import CheckboxList from './filters/CheckboxList';
import ExcludeRadio from './filters/ExcludeRadio';
import NumberRange from './filters/NumberRange';
import Radio from './filters/Radio';
import SchoolPicker from './filters/SchoolPicker';
import TextInput from './filters/TextInput';

// @vuese
// Renderer formularza danych akcji
export default {
  components: {
    Address,
    AppealDate,
    Archive,
    BeforeDocumentCreate,
    BoolRadio: Radio,
    BiK,
    CheckboxList,
    Certificate,
    Comment,
    ConfirmForm,
    ConfirmMdokSubmit,
    ConfirmPack: Confirm,
    ConfirmRemoveAnnounecment: Confirm,
    ConfirmRemoveDocument: Confirm,
    DecisionStart,
    DecisionHoldEnd: DecisionEnd,
    DecisionWithdrawalEnd: DecisionEnd,
    DeliveryDate,
    Diploma,
    ExcludeRadio,
    ExistRadio: Radio,
    FileTransfer,
    GeneralDeed,
    Invitation,
    Judgment,
    KoReport,
    Mdok,
    NoForm,
    NumberRange,
    OW004ListOfSko: ListOfSko,
    PrezydenckiData,
    Radio,
    Reason,
    SchoolPicker,
    SchoolSubmitEPUAP,
    SendToFix: Comment,
    SubmitEPUAP,
    SubmitSigned,
    SubmitSignedPrezydencki: SubmitSigned,
    SubmitManually,
    SubmitManuallyAnnouncement: SubmitManually,
    SubmitManuallyConfirm: SubmitManually,
    SubmitManuallyDuplicates: SubmitManually,
    SuspensionDateSubmit: DateRangeStart,
    TextInput,
    WithdrawalDateSubmit: DateRangeStart
  },
  mixins: [formRenderMixin]
};
</script>
